module.exports = __webpack_public_path__ + "media/images/common/tag-880a652d47c81a16b445fc6627190a78.png";